import { ICON_NAMES, iconByName } from './roomIcons';
import './IconPicker.css';

/**
 * The room's icon, picked outright — there is no type to derive it from. A
 * kitchen with a bathtub on it is a choice someone should be allowed to make.
 *
 * Selected uses the rail's --bark-muted fill, so "current" means one thing
 * throughout the app.
 */
export function IconPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (name: string) => void;
}) {
  return (
    <div className="icon-picker" role="radiogroup" aria-label="Room icon">
      {ICON_NAMES.map((name) => {
        const Icon = iconByName(name);
        const selected = name === value;
        return (
          <button
            key={name}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={name}
            className={`icon-picker__option${selected ? ' icon-picker__option--on' : ''}`}
            onClick={() => onChange(name)}
          >
            <Icon size={20} aria-hidden />
          </button>
        );
      })}
    </div>
  );
}
